import { Descriptions } from 'antd';
import { T } from 'react-translator-component';

import { formatDateTime, formatHours, formatKwh, formatMoney, maskTag } from './ocpiHelpers';
import type { Navigate } from './OcpiPage';
import * as S from './styled';

import { OcpiCdr } from '../../../types/responses/Ocpi';

interface Props {
  cdr: OcpiCdr;
  nav: Navigate;
}

/** O CDR do CS traz o total, sem composição por tarifa. */
const CdrDetail = ({ cdr, nav }: Props) => {
  const loc = cdr.cdrLocationOcpi || {};

  return (
    <>
      <S.Panel style={{ display: 'flex', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div>
          <h2 style={{ fontSize: 20, margin: 0 }}>
            {T('CDR of charge')} #{cdr.transactionPk}
          </h2>
          <div style={{ color: '#444444' }}>
            {loc.chargeBoxId || '—'} · {formatDateTime(cdr.startTimestamp)} → {formatDateTime(cdr.stopTimestamp)}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <S.Muted>{T('Total')}</S.Muted>
          <div style={{ fontSize: 26, lineHeight: '32px', fontWeight: 600 }}>{formatMoney(cdr.income, cdr.currency)}</div>
          <S.Muted>{cdr.currency}</S.Muted>
        </div>
      </S.Panel>

      <S.Grid columns={2}>
        <S.Panel style={{ marginBottom: 0 }}>
          <h2>{T('Charge data')}</h2>
          <Descriptions size="small" column={1} bordered>
            <Descriptions.Item label={T('Start')}>{formatDateTime(cdr.startTimestamp)}</Descriptions.Item>
            <Descriptions.Item label={T('End')}>{formatDateTime(cdr.stopTimestamp)}</Descriptions.Item>
            <Descriptions.Item label={T('Duration')}>{formatHours(cdr.durationHours)}</Descriptions.Item>
            <Descriptions.Item label={T('Energy')}>{formatKwh(cdr.kwh)}</Descriptions.Item>
            <Descriptions.Item label={T('Tag')}>
              <S.Mono>{maskTag(cdr.idTag)}</S.Mono>
            </Descriptions.Item>
            <Descriptions.Item label={T('Updated on')}>{formatDateTime(cdr.lastUpdated)}</Descriptions.Item>
          </Descriptions>
        </S.Panel>
        <S.Panel style={{ marginBottom: 0 }}>
          <h2>{T('Location')}</h2>
          <Descriptions size="small" column={1} bordered>
            <Descriptions.Item label={T('Station')}>{loc.chargeBoxId || '—'}</Descriptions.Item>
            <Descriptions.Item label={T('Address')}>{loc.street || '—'}</Descriptions.Item>
            <Descriptions.Item label={T('City')}>{[loc.city, loc.state].filter(Boolean).join(' / ') || '—'}</Descriptions.Item>
            <Descriptions.Item label={T('Coordinates')}>
              <S.Mono>
                {loc.locationLatitude ?? '—'}, {loc.locationLongitude ?? '—'}
              </S.Mono>
            </Descriptions.Item>
            <Descriptions.Item label={T('Connector')}>
              {[loc.connectorId, loc.connectorType].filter(Boolean).join(' · ') || '—'}
            </Descriptions.Item>
          </Descriptions>
          <div style={{ marginTop: 12 }}>
            <S.LinkButton type="button" onClick={() => nav.open({ kind: 'session', pk: cdr.transactionPk })}>
              {T('View charge')} #{cdr.transactionPk}
            </S.LinkButton>
          </div>
        </S.Panel>
      </S.Grid>
    </>
  );
};

export default CdrDetail;
